.kdx-team-card {
	border: none;
	box-shadow: none;
	padding: 14px 0;
	text-align: center;

	&.card { 
		box-shadow: none;
		border: none;
	}	
	.card-img-top {
		position: relative;
		min-height: 142px;
		border-radius: 0;

		.card-img {
			position: absolute;
			height: 142px;
			width: 142px;
			background-size: cover;
			background-repeat: no-repeat;
			border-radius: 100%;
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
	}
	.card-content {
		.card-body {
			// text-align: center;

			.tm-name {
				color:#000;
				@include text-size(36);
				@include line-height(41);
			}
			.tm-role {
				@include text-size(13);
				@include line-height(16);
				font-style: italic;
				color: #606060;				
			}			
			.detail-bio {
				display: flex;
				flex-direction: column;
				align-items: flex-start;
			}
			h3 {
				@include text-size(20);
				color: $teamMemberTitleColor;
				line-height: 24px;
				font-weight: 700;
				margin-bottom: 8px;
			}
			h4 {
				@include text-size(13);
				@include line-height(16);
				font-style: italic;
				font-family: $font-family-primary;
				color: #606060;
				font-weight: 400;
			}
			p {
				color: $gray-dark;
				@include text-size(12);
				@include line-height(18);
				margin: 0 0 16px 0;
				padding: 0px;
				max-width: 100%;
				font-weight: 400;
			}
			.card-footer {
				border-radius: 0;
				border: none;
				padding: 0px;

				a {
					margin-right: 0;
					background-color: transparent!important;
					border: none;
					color: $teamMemberReadBioColor;
					@include text-size(15);
					@include line-height(19);
					font-weight: 700;
					font-family: $font-family-secondary;
					text-decoration: none;
					transition: all 350ms linear;
					position: relative;

					&:after {
						content: '';
						background: currentColor;
						position: absolute;
						top: 100%;
						left: 0;
						width: 100%;
						height: 1px;
						opacity: 0;
						transition: opacity 350ms linear;
					}

					svg {
						@include svg-format(13px, 13px, currentColor);
						
						transition: all 350ms linear;
					}

					&:hover, &:focus {
						color: #000;

						&:after { opacity: 1; }
						svg {
							fill: $gray-dark;
							transform: translateX(7px);
							transition: all 350ms linear;
						}
					}
				}
				
			}

			.icon-row {
				margin-top: 13px;
				display: flex;
				position: relative;
				justify-content: center;

				.icon {
					position: relative;
					height: 45px;
					width: 45px;
					border-radius: 100%;
					border: 1px solid #DEDEDE;
					margin: 0px 5px;
					box-shadow: none;
					transition: all 350ms linear;

					.tm-icon svg {
						fill: $teamMemberSocialIcons;
						color: #202B3C;						
					}
					svg {
						position: absolute;
						top: 50%;
						left: 50%;
						transform: translate(-50%, -50%);
						@include svg-format(15px, 19px, currentColor);
						color: $teamMemberSocialIcons;
						transition: all 350ms linear;
					}

					&:hover, &:focus {
						background: $teamMemberSocialIconsHover;
						box-shadow: $teamMemberSocialIconsBoxShadow;
						transform: translateY(-7px);
						@include transitionDefault(transform);
						
						svg {
							color: #FFF;
							fill: #FFF;
						}
					}
				}
			}
		}
	}

	&.hero-card {
		flex-direction: row;

		.card-img-top {
			max-width: 172px;
			min-height: 172px;

			.card-img {
				height: 172px;
				width: 172px;
			}
		}
		.card-content {
			align-items: flex-start;

			.card-body {
				padding-left: 30px;
				text-align: left;

				.tm-name {
					@include text-size(42);
					@include line-height(46);					
					color: $teamBioHeroName;					
					margin: 0 0 8px 0;
				}
				.tm-role {
					@include text-size(21);
					@include line-height(32);
					color: $teamBioHeroRole;
					margin: 0 0 16px 0;
				}
				.icon-row {
					justify-content: flex-start;
					align-items: center;

					.tm-circle {
						background: #FFF;
						border: 1px solid $gray-lite;

						&:hover, &:focus {
							background: $teamBioHeroSocialIconsHoverBg;
							box-shadow: $teamMemberSocialIconsBoxShadow;
							border: 1px solid $teamBioHeroSocialIconsHoverBg;

							svg {
								fill: $teamBioHeroSocialIconsHoverSvg;
							}
						}
					}					
				}
			}
		}
	}	
}

.col .kdx-team-card {
	display: block;
	height: 100%;

	.kdx-team-card {
		height: 100%;
	}
}






@include media-breakpoint-down(lg) {
	.kdx-team-card {
		padding: 5px;

		.card-img-top {
			min-height: 100px;

			.card-img {
				height: 100px;
				width: 100px;
			}
		}

		&.hero-card {
			flex-direction: column;
	
			.card-img-top {
				max-width: 100%;
	
				.card-img {
					height: 172px;
					width: 172px;
				}
			}	
			.card-content {
				align-items: center;
	
				.card-body {
					text-align: center;					
						
					.tm-name {
						@include text-size(32);
						line-height: 37px;
					}	
					.tm-role {
						@include text-size(18);
						line-height: 29px;
					}	
					.icon-row {
						justify-content: center;
						flex-wrap: wrap;
						max-width: 200px;
						margin: 0 auto;	
						
					}
				}				
			}
		}
	}
}